import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeTTS extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
